import { type Dispatch, useEffect } from 'react';
import { debounce } from 'ts-debounce';
import type { PrepackageSearchState } from '../../types';
import actions from '../prepackageActions';
import { buildParams } from '../utils/buildParams';

type UsePrePackageTotalOffersProps = {
    state: PrepackageSearchState;
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>;
    totalOffersUrl: string;
};

export const usePrepackageTotalOffers = ({ state, dispatch, totalOffersUrl }: UsePrePackageTotalOffersProps) => {
    const getTotalOffers = (): void => {
        const params = buildParams(state);
        dispatch(actions.setTotalOffers(null));

        fetch(`${totalOffersUrl}?${params}`, { method: 'GET' })
            .then((response) => response.json())
            .then((data) => dispatch(actions.setTotalOffers(Number(data))))
            .catch(() => dispatch(actions.setTotalOffers(null)));
    };

    const debouncedGetTotalOffers = debounce(getTotalOffers, 350);

    useEffect(() => {
        debouncedGetTotalOffers();
    }, [
        state.searchType,
        state.originAirport,
        state.boundingBox,
        state.destinations,
        state.departureDate,
        state.returnDate,
        state.flexibleDeparture,
        state.duration,
        state.travelMonths,
        state.numberOfAdults,
        state.agesOfChildren,
    ]);
};
